import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import React from "react";
import { computeTotalPackages } from "../overstay-fees-report";

const AggregateStorageRentalFeesTable = ({
  dt,
  showMorePaymentDetails,
  items = [
    {
      column1: "Column 2",
      column2: "Column 2",
    },
  ],
  isStorage = true,
}) => {
  const rowClassName = (rowData) => {
    if (rowData.transActStatus === 1) {
      return "bg-green-300 border border-black";
    } else if (rowData.transActStatus === 2) {
      return "bg-red-300 border border-black";
    }
    return "border border-black";
  };

  return (
    <DataTable
      paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="Rows per page"
      paginator
      paginatorRight
      rowsPerPageOptions={[10, 20, 50]}
      value={items}
      rows={10}
      // headerColumnGroup={headerGroup}
      rowClassName={rowClassName}
      sortMode="multiple"
      sortField="name"
      sortOrder={1}
      stripedRows
      header={`Total Packages: ${computeTotalPackages(items)}`}
      showGridlines={true}
      exportFilename="Overstay Fees Report"
      tableStyle={{
        minWidth: "50rem",
        // bor
        borderWidth: 2,
        borderColor: "#E6E6E6",
      }}
      style={{
        borderWidth: "2",
      }}
      removableSort
      ref={dt}
      emptyMessage={"No transactions found"}
      cellSelection={true}
      onCellClick={(e) => {
        if (e.rowData.packageId != null && e.field == "waybillNumber") {
          window.open(
            `/operator/admin/view-package-history/${e.rowData.packageId}/${e.rowData.userId}`,
            "_blank"
          );
        }
        if (e.rowData.recipientId != null && e.field == "recipientMobile") {
          window.open(
            `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.recipientId}`,
            "_blank"
          );
        }
        if (e.rowData.senderId != null && e.field == "senderMobile") {
          if (e.rowData.serviceType === "Storage") {
            window.open(
              `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.senderId}`,
              "_blank"
            );
          } else {
            window.open(
              `/operator/admin/agents/agentProfile/${e.rowData.senderId}`,
              "_blank"
            );
          }
        }
      }}
    >
      <Column
        field="status"
        header="Status"
        alignHeader={"center"}
        sortable
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        body={(rowData) => {
          return (
            <Tag
              value={
                rowData.status === "1"
                  ? "Successful"
                  : rowData.status === "2"
                  ? "Failed"
                  : "Refunded"
              }
              severity={
                rowData.status === "1"
                  ? "success"
                  : rowData.status === "2"
                  ? "danger"
                  : "warning"
              }
              className="text-secondary-purpleGray"
            />
          );
        }}
      />

      {/* <Column
                  field="serviceType"
                  className={`text-center max-w-[200px] break-words `}
                  headerClassName="bg-primary-primaryYellow text-center"
                  // sortable
              /> */}
      <Column
        field="lockerName"
        header="Locker Name"
        alignHeader={"center"}
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        sortable
      />

      {isStorage && (
        <Column
          field="doorsizeId"
          header="Door Size"
          alignHeader={"center"}
          className={`text-center max-w-[200px] break-words `}
          headerClassName="bg-primary-primaryYellow text-center"
          sortable
        />
      )}

      <Column
        field="totalTransactions"
        header="Total Transactions"
        alignHeader={"center"}
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        sortable
      />

      <Column
        field="duplicateCount"
        header="Total Duplicates"
        alignHeader={"center"}
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        sortable
      />

      <Column
        field="paymentAmount"
        header="Total Payment Amount"
        alignHeader={"center"}
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        sortable
        body={(rowData) => (
          <div>
            {rowData.paymentCurrency === "PHP"
              ? `₱ ${rowData.paymentAmount.toFixed(2)}`
              : rowData.paymentAmount.toFixed(2)}
          </div>
        )}
      />

      <Column
        header="Payment Currency"
        alignHeader={"center"}
        field="paymentCurrency"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        sortable
      />

      {/* {showMorePaymentDetails && ( */}
      <Column
        field="paymentGateway"
        header="Payment Gateway"
        alignHeader={"center"}
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
      />
    </DataTable>
  );
};

export default AggregateStorageRentalFeesTable;
